import { styled } from 'goober';
import Button from 'preact-material-components/Button';
import 'preact-material-components/Button/style.css';
import { useSalesDispatchContext } from '../../storeProviders/salesAppStore';
import { useState, useEffect } from 'preact/hooks';

const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .title {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: var(--primaryCTAColor);
    text-align: center;
    max-width: 345px;
    margin-top: 42px;
  }
  .desc {
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #000;
    max-width: 345px;
    margin: 16px 0px 48px;
    text-align: center;
  }
  .okBtn {
    width: 318px;
    height: 50px;
    margin: 0 auto 16px;
    background-color: var(--primaryCTAColor);
    border-radius: 8px;
    border-color: transparent;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #ffffff;
    text-transform: capitalize;
  }
`;

const SaShareInfoSheet = () => {
  const salesDispatch = useSalesDispatchContext();
  const defautlMessage =
    'Your current browser does not support the sharing directly, Please manually share the information with customer.';
  const webShareNotSupported =
    "Your browser doesn't support direct sharing. The image will download to your device automatically. Please share it manually with the customer.";
  const webShareAndDownloadNotSupported =
    'As your device/browser does not support sharing, please capture a screenshot of the information and share it with the customer.';

  const [message, setMessage] = useState(defautlMessage);
  const title = 'Share EMI Information';

  useEffect(() => {
    if (!!!navigator.share) {
      setMessage(webShareNotSupported);
    }
    if (!!!navigator.share && navigator.userAgent.match(/Firefox/i)) {
      setMessage(webShareAndDownloadNotSupported);
    }
  }, []);

  const handleCloseModal = () => {
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: false,
          moduleName: null,
        },
      },
    });
  };

  return (
    <Container>
      <div className='title'>{title}</div>
      <div className='desc'>{message}</div>
      <Button className='okBtn' onClick={handleCloseModal}>
        Ok
      </Button>
    </Container>
  );
};

export default SaShareInfoSheet;



// WEBPACK FOOTER //
// ./components/salesApp/SaShareInfoSheet.js